export default "__VITE_ASSET__DnHC7iif__"